import * as types from '../constants/ActionTypes';


const INITIAL_STATE = {
    error: null,
    conversationList: [],
    latestMessages: [],
};

export default function menuReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.GET_ALL_CONVERSATIONS_SUCCESS:
            return {
                ...state,
                error: null,
                conversationList: action.response.conversations,
            };

        case types.CONVERSATION_ERROR:
            console.error(types.CONVERSATION_ERROR, action);
            return {
                ...state,
                error: {
                    type: action.type,
                    status: action.response.status,
                    data: action.response.data,
                },
            };

        default:
            return state;
    }
}
